import { filter, first } from '../utils/collection.utils';
import { getCurrentMillis } from '../utils/date.utils';
import { ArticleVersion } from './article-version';
import { Client } from './client';
import { FilterableInterface } from './filterable.interface';
import { ManufacturingOrderFile } from './manufacturing-order-file';
import { ManufacturingOrderIncidence } from './manufacturing-order-incidence';
import { Material } from './material';

export const STOCK_VALUE = 'STOCK';
export class ManufacturingOrder implements FilterableInterface {
  constructor(
    public hash?: string,
    public code?: string,
    public project?: string,
    public customer?: string,
    public subCustomer?: string,
    public reference?: string,
    public observations?: string,
    public lastSynchronization?: number,
    public materials?: Material[],
    public planeLink?: string,
    public projectNumber?: string,
    public manufacturingOrderFeature?: string,
    public manufacturingOrderIncidence?: ManufacturingOrderIncidence,
    public manufacturingOrderFile?: ManufacturingOrderFile,
    public situation?: string,
    public deliveryDate?: number,
    public entryNumber?: string,
    public existsPDF?: Boolean,
    public routeCode?: string,
    public mainManufacturingOrder?: string,
    public quantity?: number,
    public articleVersion?: ArticleVersion,
    public client?: Client,
    public articleNumber?: string,
    public articleHash?: string,
    public latheDate?: number,
    public mpReady?: string,
    public hasMaterialReady?: boolean,
    public hasMaterialInStock?: boolean,
    public isClaimed?: boolean,
    public isDeliveryChanged?: boolean,
    public isUrgent?: boolean,
    public timeDays?: number,
    public hasMaterialEdited?: boolean,
    public plannerObservations?: string,
    public hasQuantityEdited?: boolean,
    public hasDeliveryDateEdited?: boolean,
    // Bloqueada desde Proyecto OF: se planifica pero no se envía a máquina.
    public blocked?: boolean,
  ) {}

  clone() {
    return new ManufacturingOrder(
      this.hash,
      this.code,
      this.project,
      this.customer,
      this.subCustomer,
      this.reference,
      this.observations,
      this.lastSynchronization,
      this.materials,
      this.planeLink,
      this.projectNumber,
      this.manufacturingOrderFeature,
      this.manufacturingOrderIncidence,
      this.manufacturingOrderFile,
      this.situation,
      this.deliveryDate,
      this.entryNumber,
      this.existsPDF,
      this.routeCode,
      this.mainManufacturingOrder,
      this.quantity,
      this.articleVersion,
      this.client,
      this.articleNumber,
      this.articleHash,
      this.latheDate,
      this.mpReady,
      this.hasMaterialReady,
      this.hasMaterialInStock,
      this.isClaimed,
      this.isUrgent,
      this.isDeliveryChanged,
      this.timeDays,
      this.hasMaterialEdited,
      this.plannerObservations,
      this.hasQuantityEdited,
      this.hasDeliveryDateEdited,
      this.blocked
    );
  }

  get filterableData() {
    return `${this.code} ${this.customer} ${this.subCustomer} ${this.reference} ${this.project}`.toLowerCase();
  }

  get codeWithNumber() {
    return `${this.code}/${this.projectNumber}`;
  }

  get articleNum() {
    return `${
      this.articleVersion &&
      this.articleVersion.article &&
      this.articleVersion.article.articleNumber
        ? this.articleVersion.article.articleNumber
        : '-'
    }`;
  }

  get articleDescription() {
    return `${
      this.articleVersion &&
      this.articleVersion.article &&
      this.articleVersion.article.description
        ? this.articleVersion.article.description
        : '-'
    }`;
  }

  get codeArticleNumber() {
    return this.code && this.articleNumber
      ? `${this.code} - ${this.articleNumber}`
      : this.code;
  }

  get material() {
    const filterMaterials: Material[] = filter(
      (material: Material) => material.orderNumber === 5,
      this.materials
    );
    return first(filterMaterials);
  }

  get hasMaterialOk() {
    return this.mpReady && !this.mpReady.toUpperCase().includes(STOCK_VALUE);
  }

  get hasMaterialStock() {
    return (
      !this.hasMaterialOk &&
      this.mpReady &&
      this.mpReady.toUpperCase().includes(STOCK_VALUE)
    );
  }

  get hasMaterialWithAcutalDeliveryDate() {
    return (
      !this.hasMaterialOk &&
      !this.hasMaterialStock &&
      this.material &&
      this.material.deliveryDate &&
      this.material.deliveryDate > getCurrentMillis()
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/manufacturing-order.ts